import { deepKeysToSnake } from '@eventbrite/legacy-infra.transformation-utils';
import { fetchEB, formatUrl } from '@eventbrite/legacy-infra.http';

import { pruneObject } from '../utils';

const GET_PLACE_FROM_GOOGLE_PLACE_ID_URL = '/home/api/geo/place_from_google_place_id/';
const GET_PLACE_FROM_COORDINATES_URL = '/home/api/geo/place_from_coordinates/';

export const getPlaceFromGooglePlaceId = (
    googlePlaceId,
    excludeNeighborhoods,
    enableNeighborhoodsAndBoroughs,
) => {
    const queryParams = deepKeysToSnake(
        pruneObject({
            googlePlaceId,
            excludeNeighborhoods,
            enableNeighborhoodsAndBoroughs,
        }),
    );

    return fetchEB(formatUrl(GET_PLACE_FROM_GOOGLE_PLACE_ID_URL, queryParams)).then((res) =>
        res.json(),
    );
};

export const getPlaceFromCoordinates = ({ latitude, longitude, excludeNeighborhoods }) => {
    const queryParams = deepKeysToSnake(
        pruneObject({
            latitude,
            longitude,
            excludeNeighborhoods,
        }),
    );

    return fetchEB(formatUrl(GET_PLACE_FROM_COORDINATES_URL, queryParams)).then((res) =>
        res.json(),
    );
};
